import React, {Component} from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../../../utils/translations';
import {FormTextAreaMinMax} from '@homeaway/react-form-components';
import TravelerModification from './TravelerModification';

export const CancellationReason = (props) => {
    const {reason, translations} = props;

    return (
        <div className="cancel-trip-modal-form CancelTrip__step">
            <div className="js-cancel-instructions">
                <h3 className="js-cancel-category-text">{props.title}</h3>
                {reason && reason.key && (
                    <p className="js-cancel-reason-key">{reason.key}</p>
                )}
                <p className="js-cancel-description">{props.description}</p>
            </div>
            <FormTextAreaMinMax
                id={'CancelTrip__message'}
                label={translate(
                    translations,
                    'trav-dash/trav-home',
                    'messages',
                    'th.inbox.conversation.cancel.form'
                )}
                maxChars={1000}
                onChange={props.onChange}
                rows={5}
                value={props.value}
            />
            {reason && reason.reason === 'NONE_OF_ABOVE' && (
                <p className="small js-cancel-required-message">
                    <strong>
                        {translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.inbox.conversation.cancel.message.required'
                        )}
                    </strong>
                </p>
            )}
        </div>
    );
};

export class CancelTripModalForm extends Component {
    static propTypes = {
        labels: PropTypes.shape({
            formLabel: PropTypes.string,
            required: PropTypes.string,
        }),
        onChange: PropTypes.func,
        reason: PropTypes.shape({
            key: PropTypes.string,
            reason: PropTypes.string,
        }),
        shortDisplayName: PropTypes.string,
        showsTravelerModificationFlow: PropTypes.bool,
        title: PropTypes.string,
        translations: PropTypes.shape({}),
        value: PropTypes.string,
    };

    static defaultProps = {
        translations: {},
    };

    render() {
        const {showsTravelerModificationFlow} = this.props;

        return showsTravelerModificationFlow ? (
            <TravelerModification {...this.props} />
        ) : (
            <CancellationReason {...this.props} />
        );
    }
}
